export default "__VITE_ASSET__Bqa7NVbp__"